<template>
  <div v-bind:style="{ height: compheight }">
    <!-- <div :id="editorId" class="editor" style="width: 100%; height: 100%"></div> -->
    <div :id="editorId" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import { bus } from "@/bus.js";
import * as ace from "brace";
import "brace/ext/language_tools.js";
import "brace/ext/searchbox.js";

import "brace/mode/lua";
import "brace/mode/yaml";
import "brace/mode/html";
import "brace/theme/monokai";

export default {
  props: [
    "editorId",
    "content",
    "lang",
    "theme",
    "height",
    "onUpdateContent",
    "additionalParams",
    "readOnly",
    "options",
    "onPaste",
  ],
  data() {
    return {
      editor: null,
      editorOptions: {
        fontSize: 14,
        fontFamily: "monospace",
        printMargin: false,
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
      },
      buffer: null,
    };
  },

  watch: {
    readOnly() {
      this.editor.setReadOnly(this.readOnly);
    },
    lang(){
      if (this.lang) {
          this.editor
            .getSession()
            .setMode(`ace/mode/` + (this.lang ? this.lang : "lua"));
        }
    }
    //content() {
    //  two way binding – emit changes to parent
    // this.$emit("input", this.content);
    //  update value on external model changes
    //  if (this.oldValue !== this.content) {
    //    this.editor.setValue(this.content, 1);
    //  }
    //},
  },

  computed: {
    compheight() {
      return (this.height ? this.height : 400) + "px";
    },
  },
  created() {
    let that = this;
    bus.$on("get-code", function (data) {
      // let code = that.editor.getModel().getValue();
      // that.$emit("onCode", code.replace(new RegExp("\n", "g"), "\r\n"));
    });
  },
  mounted() {
    let that = this;
    this.$nextTick(function () {
      if (this.editor === null) {
        this.editor = ace.edit(this.editorId);
        if (this.lang) {
          this.editor
            .getSession()
            .setMode(`ace/mode/` + (this.lang ? this.lang : "lua"));
        }
        if (this.onPaste) {
          this.editor.onPaste = this.onPaste;
        }

        this.editor.setTheme(
          `ace/theme/` + (this.theme ? this.theme : "vikingo")
        );

        this.editor.setReadOnly(this.readOnly);
        this.editor.$blockScrolling = Infinity;
        const session = this.editor.getSession();
        session.on("changeAnnotation", () => {
          const a = session.getAnnotations();
          const b = a.slice(0).filter((item) => item.text.indexOf("DOC") == -1);
          if (a.length > b.length) session.setAnnotations(b);
        });

        if (this.options) {
          for (let key in Object.keys(this.options)) {
            this.editorOptions[key] = this.options[key];
          }
        }
        this.editor.setOptions(this.editorOptions);

        if (this.content && this.content !== "") {
          this.setValue(this.content);
        }

        if (typeof this.onUpdateContent == "function") {
          this.editor.on("change", (newValue) => {
            that.onUpdateContent(that.editor.getValue(), that.additionalParams);
            //  oldValue set to prevent internal updates
            // this.content = this.oldValue = this.editor.getValue();
          });
        }
        /* start test */
        if (this.lang == "httpreq") {
          var staticWordCompleter = {
            getCompletions: function (editor, session, pos, prefix, callback) {
              var wordList = [
                "Authorization: ",
                "User-Agent: ",
                "Cookie: ",
                "Content-Type: ",
                "Origin: ",
                "Referer: ",
                "Bearer",
                "Host:",
                "Accept-Encoding: gzip, deflate, br",
                "Accept:",
                "Accept-Language:",
                "application/x-www-form-urlencoded",
                'multipart/form-data;boundary="boundary"',
              ];
              callback(
                null,
                wordList.map(function (word) {
                  return {
                    caption: word,
                    value: word,
                    meta: "static",
                  };
                })
              );
            },
          };

          // langTools.setCompleters([staticWordCompleter]);
          // or
          this.editor.completers = [staticWordCompleter];
        }
        /* end test */
      }
    });
  },
  methods: {
    loadFromBuffer() {
      if (this.editor) {
        if (this.buffer !== null) {
          this.editor.setValue(this.buffer);
          this.buffer = null;
        }
      } else {
        console.log("not loaded.....");
        // setTimeout(this.loadFromBuffer, 100);
      }
    },
    setValue(v) {
      this.$nextTick(function () {
        this.editor.setValue(v, 1);
      });
      /*
      if (this.editor) {
        this.editor.setValue(v);
      } else {
        this.buffer = v;
        this.$nextTick(function () {
          this.loadFromBuffer();
        });
      }
      */
    },
    getValue() {
      return this.editor.getValue();
    },
  },
  beforeDestroy() {
    // this.editor && this.editor.getModel().dispose() && this.editor.dispose();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/internal/Editor.vue